import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import chartService from './service';

export const useChart = () => {
  return useService(chartService, (state) => state);
};

export const useChartWithKeys = getUseServiceWithSubscriptionKeys(chartService);

export { chartService };
